<!-- =========================================================================================
  File Name: Product.vue
  Description: Product product Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="mb-2" v-if="loaded">

      <div slot="no-body" class="tabs-container pl-6 py-3">
        <div class="w-full vx-row mb-2">
          <div class="vx-col w-3/12">
            <ejs-textbox floatLabelType="Auto" placeholder="ISBN" :enabled="editing" v-model="data_local.isbn"/>
          </div>
          <div class="flex vx-col w-9/12 items-center justify-end h-full">
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="save" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-save" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Guardar cambios</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm border border-solid border-warning cursor-pointer" @click="reset_data" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-corner-up-left" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Cancelar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="editing = true" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-edit-2" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Editar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-danger text-white cursor-pointer" @click="confirmDeleteRecord" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-x" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Eliminar</div>
            </div>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-full">
            <ejs-textbox floatLabelType="Auto" placeholder="Nombre" :enabled="editing" v-model="data_local.name"/>
          </div>
        </div>
        <vs-tabs>
          <vs-tab label="Datos de venta">
            <div class="w-full vx-row">
              <div class="vx-col w-1/6">
                <ejs-numerictextbox floatLabelType="Auto" placeholder="Precio actual" format="N2" :enabled="editing" textAlign='Right' v-model="data_local.price" :min="0" :showSpinButton="false" :step="0.01"/>
              </div>
              <div class="vx-col w-auto flex items-center justify-center px-2" v-if="editing">
                <vx-tooltip text="Cargar precio de Odoo" position="top">
                  <vs-button icon-pack="feather" icon="icon-download" size="small" @click="fetchOdooPrice" color="primary" type="border"/>
                </vx-tooltip>
              </div>
              <div class="vx-col w-1/6">
                <ejs-numerictextbox floatLabelType="Auto" placeholder="Precio original" format="N2" :enabled="editing" textAlign='Right' v-model="data_local.originalPrice" :min="0" :showSpinButton="false" :step="0.01"/>
              </div>
              <div class="vx-col w-1/12">
                <ejs-numerictextbox floatLabelType="Auto" placeholder="% Descuento" format="N0" :enabled="editing" textAlign='Right' v-model="data_local.discount" :min="0" :max="99" :showSpinButton="false" :step="1"/>
              </div>
              <div class="vx-col w-1/4">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Estado" highlight=true :dataSource="status" :fields="{text: 'value', value: 'id'}" v-model="data_local.status" :enabled="editing"></ejs-dropdownlist>
              </div>
              <div class="vx-col w-1/4 my-3">
                <ejs-checkbox label='Disponible en tienda en línea' v-model="data_local.available" :checked="data_local.available" :disabled="!editing"></ejs-checkbox>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-1/2">
                <ejs-multiselect ref="categories" floatLabelType="Auto" placeholder="Incluir en categorías" :dataSource="categories" mode="Box" :fields="{text: 'displayName', value: 'id'}" v-model="data_local.categoryList" :enabled="editing"></ejs-multiselect>
              </div>
              <div class="vx-col w-1/4">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Versión" highlight=true :dataSource="versions" :fields="{text: 'name', value: 'id'}" v-model="data_local.versionId" :enabled="editing"></ejs-dropdownlist>
              </div>
              <div class="vx-col w-1/4">
                <ejs-numerictextbox floatLabelType="Auto" placeholder="Cantidad de imágenes" format="N0" :enabled="false" textAlign='Right' v-model="data_local.imageCount" :min="0" :showSpinButton="false" :step="1"/>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-full">
                <ejs-multiselect ref="variations" floatLabelType="Auto" placeholder="Productos relacionados" :dataSource="products" mode="Box" :fields="{text: 'displayName', value: 'id'}" v-model="data_local.variationsList" :enabled="editing"></ejs-multiselect>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-1/3 my-3">
                <ejs-checkbox label='Producto en promoción' v-model="data_local.onSale" :checked="data_local.onSale" :disabled="!editing"></ejs-checkbox>
              </div>
              <div class="vx-col w-1/3" v-show="data_local.onSale">
                <ejs-numerictextbox floatLabelType="Auto" placeholder="Precio promoción" format="N2" :enabled="editing" textAlign='Right' v-model="data_local.salePrice" :min="0" :showSpinButton="false" :step="0.01"/>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Características">
            <div class="w-full vx-row">
              <div class="vx-col w-1/3">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Tipo de letra" highlight=true :dataSource="fontSizes" :fields="{text: 'name', value: 'id'}" v-model="data_local.fontSizeId" :enabled="editing"></ejs-dropdownlist>
              </div>
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Tapa" :enabled="editing" v-model="data_local.cover"/>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Color" :enabled="editing" v-model="data_local.color"/>
              </div>
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Concordancia" :enabled="editing" v-model="data_local.concordance"/>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-full">
                <ejs-textbox floatLabelType="Auto" placeholder="URL de video" :enabled="editing" v-model="data_local.videoURL"/>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Descripción">
            <div class="w-full vx-row">
<!--              <div class="vx-col w-full">-->
<!--                <ejs-textbox name="description" :multiline="true" floatLabelType="Auto" placeholder="Descripción completa del producto" v-model="data_local.description" :enabled="editing"/>-->
<!--              </div>-->
              <div class="vx-col w-full">
                <ejs-richtexteditor ref="description" :height="400" :readonly="!editing" placeholder="Especifique una descripción amplia del producto" v-model="data_local.description"></ejs-richtexteditor>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Imágenes">

            <div class="w-full flex flex-row flex-wrap justify-start items-center mt-4 p-2">
              <div
                class="flex flex-col w-1/4 my-4 block bg-contain bg-no-repeat bg-center items-end justify-between border border-dotted border-primary"
                :style="{ 'background-image': `url(${previewImage})`}"
                style="height: 400px; background-repeat: no-repeat; background-position: center center;"
              >
                <div class="w-full p-2">
                  <h4 class="w-full">Imagen principal</h4>
                </div>
                <input
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  @input="pickFile(null)"
                  class="opacity-0 absolute"
                />
                <div class="flex w-full items-end justify-between">
                  <vs-button class="ml-2 mb-2" color="success" icon-pack="feather" icon="icon-image" @click="selectImage(null)" v-if="editing">Seleccionar</vs-button>
                  <vs-button class="mr-2 mb-2" color="danger" icon-pack="feather" icon="icon-x" @click="removeMainImage()" v-if="editing">Eliminar</vs-button>
                </div>
              </div>
              <div v-for="image in extraImages" :key="image.id"
                   class="flex flex-col w-1/4 my-4 ml-1 block bg-contain bg-no-repeat bg-center items-end justify-between border border-dotted border-primary"
                   :style="{ 'background-image': `url(${image.preview})`}"
                   style="height: 400px; background-repeat: no-repeat; background-position: center center;"
              >
                <div class="w-full p-2">
                  <h4 class="w-full">{{ image.id }}</h4>
                </div>
                <input
                  :ref="`fileInput_${image.id}`"
                  type="file"
                  accept="image/*"
                  @input="pickFile(image)"
                  class="opacity-0 absolute"
                />
                <div class="flex w-full items-end justify-between">
                  <vs-button class="ml-2 mb-2" color="success" icon-pack="feather" icon="icon-image" @click="selectImage(image)" v-if="editing">Seleccionar</vs-button>
                  <vs-button class="mr-2 mb-2" color="danger" icon-pack="feather" icon="icon-x" @click="removeExtraImage(image)" v-if="editing">Eliminar</vs-button>
                </div>
              </div>
              <div class="flex items-center justify-start p-8" v-if="editing">
                <vs-button icon="library_add" color="success" radius size="large" @click="addImageSlot()"/>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>

    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
import {CheckBoxPlugin} from "@syncfusion/ej2-vue-buttons";
import {DropDownListPlugin, MultiSelectPlugin} from "@syncfusion/ej2-vue-dropdowns";
import {RichTextEditorPlugin, Toolbar, Count, HtmlEditor, QuickToolbar} from '@syncfusion/ej2-vue-richtexteditor';
import {firebase, db, storage} from '@/firebaseConfig';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(RichTextEditorPlugin);

export default {
  data() {
    return {
      loaded: false,
      activeTab: 0,
      editing: false,
      id: 0,
      data: null,
      status: [{id: 'ACT', value: 'Activo'}, {id: 'IN', value: 'Inactivo'}],
      imageChanged: false,
      data_local: {
        id: 0,
        isbn: '',
        name: '',
        description: '',
        categoryId: '',
        versionId: '',
        categoryList: [],
        variationsList: [],
        price: 0.0,
        originalPrice: 0.0,
        discount: 0,
        availableInPOS: true,
        combo: false,
        comments: '',
        status: '',
        onSale: false,
        salePrice: 0,
        stock: 0,
        cover: '',
        concordance: '',
        fontSizeId: '',
        videoURL: '',
        imageCount: 0
      },
      id_not_found: false,
      currentStatus: 0,
      uploadFieldName: 'photos',
      previewImage: null,
      extraImages: [],
      imageSlots: {},
      extraSlotCount: 0,
      pendingImageMoves: [],
      pendingImageDeletes: []
    }
  },
  provide: {
    richtexteditor:[Toolbar, Count, HtmlEditor, QuickToolbar]
  },
  computed: {
    imagesURL() {
      return this.$store.getters['getParameter']('images').baseURL;
    },
    categories() {
      return this.$store.getters.categoriesList;
    },
    products() {
      return this.$store.getters.productsList;
    },
    versions() {
      return this.$store.getters.versionsList;
    },
    fontSizes() {
      return this.$store.getters.fontSizesList;
    },
    image() {
      const imageURL = [this.imagesURL, '/products%2F', this.$data.data.id, '.png?alt=media'].join('');
      return imageURL;
    }
/*
    extraImages() {
      const list = [];
      if (this.data_local.imageCount > 0) {
        let letter = '';
        for (let i = 0; i < this.data_local.imageCount; i++) {
          letter = String.fromCharCode(i + 97);
          list.push({
            id: letter,
            imageName: `${this.data_local.id}${letter}.png`,
            preview: [this.imagesURL, '/products%2F', this.data_local.id, letter, '.png?alt=media'].join('')
          })
        }
      }
      return list;
    }
*/
  },
  methods: {
    reset_data() {
      if (this.id > 0) {
        if (this.$refs.images) {
          console.log(this.$refs.images);
        }
        this.imageChanged = false;
        this.data_local = {...this.data_local, ...JSON.parse(JSON.stringify(this.data))};
        this.data_local.categoryId = this.data.categoryId.toString();
        this.data_local.versionId = this.data.versionId.toString();
        this.data_local.categoryList = this.data.categories ? this.data.categories.split(',') : [];
        this.data_local.variationsList = this.data.variations ? this.data.variations.split(',') : [];
        if (!this.data_local.hasOwnProperty('imageCount')) {
          this.data_local.imageCount = 0;
        }
        this.extraSlotCount = this.data_local.imageCount;
        this.pendingImageMoves = [];
        this.pendingImageDeletes = [];
        this.syncExtraImages(this.extraSlotCount, true);
        this.previewImage = this.image;
        this.editing = false;
        this.loaded = true;
      } else {
        this.$router.push({name: 'products'});
      }
    },
    getInputRef(image) {
      if (image == null) {
        return this.$refs.fileInput;
      }
      const fileInput = this.$refs[`fileInput_${image.id}`];
      return Array.isArray(fileInput) ? fileInput[0] : fileInput;
    },
    selectImage(image) {
      const input = this.getInputRef(image);
      if (input) {
        input.click();
      }
    },
    removeMainImage() {
      this.previewImage = null;
      const input = this.$refs.fileInput;
      if (input) {
        input.value = '';
      }
    },
    removeExtraImage(image) {
      if (image.preview) {
        // El slot tiene una imagen seleccionada: solo se quita la imagen (comportamiento actual)
        image.preview = null;
        image.file = null;
        image.removed = true;
        const input = this.getInputRef(image);
        if (input) {
          input.value = '';
        }
        this.recalcImageCount();
      } else {
        // El slot no tiene imagen seleccionada: se elimina el slot completo y se renumeran los restantes
        this.removeImageSlot(image);
      }
    },
    removeImageSlot(image) {
      // La letra más alta antes de eliminar el slot: si ningún slot sobreviviente la reclama
      // como destino de un movimiento/subida, es la única que queda huérfana y debe limpiarse.
      // No se debe borrar directamente la letra del slot eliminado, porque esa misma letra
      // normalmente es reutilizada de inmediato como destino del slot siguiente que se recorre.
      const oldMaxLetter = this.extraImages.length > 0 ? String.fromCharCode(this.extraImages.length - 1 + 97) : null;
      let oldMaxLetterClaimed = false;
      const remaining = this.extraImages.filter(item => item.id !== image.id);
      const newImageSlots = {};
      const newExtraImages = [];
      remaining.forEach((item, index) => {
        const newLetter = String.fromCharCode(index + 97);
        let preview = item.preview;
        if (item.id !== newLetter) {
          if (item.id === oldMaxLetter) {
            oldMaxLetterClaimed = true;
          }
          if (item.file) {
            // Ya se eligió un archivo nuevo para este slot: el archivo se sube a la letra nueva,
            // por lo que solo se debe limpiar el contenido remanente en la letra anterior
            this.pendingImageDeletes.push(item.id);
          } else if (!item.removed && item.preview) {
            // Se conserva el contenido ya almacenado en Storage, moviéndolo a la nueva letra
            this.pendingImageMoves.push({fromLetter: item.id, toLetter: newLetter});
            preview = [this.imagesURL, '/products%2F', this.data_local.id, newLetter, '.png?alt=media'].join('');
          } else {
            this.pendingImageDeletes.push(item.id);
          }
        }
        const updatedItem = {
          ...item,
          id: newLetter,
          imageName: `${this.data_local.id}${newLetter}.png`,
          preview
        };
        newExtraImages.push(updatedItem);
        newImageSlots[newLetter] = updatedItem;
      });
      // Si ningún slot sobreviviente reclamó la letra más alta anterior, su contenido en Storage
      // (si existía) quedó huérfano y debe limpiarse; si ya fue reclamada, su limpieza queda a
      // cargo del propio movimiento (moveExtraImage borra el origen tras copiar el contenido)
      if (oldMaxLetter && !oldMaxLetterClaimed) {
        this.pendingImageDeletes.push(oldMaxLetter);
      }
      this.imageSlots = newImageSlots;
      this.extraImages = newExtraImages;
      this.extraSlotCount = newExtraImages.length;
      this.recalcImageCount();
    },
    addImageSlot() {
      this.extraSlotCount++;
      this.syncExtraImages(this.extraSlotCount);
      this.$nextTick(() => {
        const newImage = this.extraImages[this.extraImages.length - 1];
        if (newImage) {
          this.selectImage(newImage);
        }
      });
    },
    recalcImageCount() {
      // "Cantidad de imágenes" se calcula automáticamente en función de las imágenes
      // adicionales que realmente tienen contenido en la pestaña de Imágenes
      let lastFilledIndex = -1;
      this.extraImages.forEach((image, index) => {
        if (image.preview) {
          lastFilledIndex = index;
        }
      });
      this.data_local.imageCount = lastFilledIndex + 1;
    },
    syncExtraImages(count, resetPreview) {
      if (resetPreview) {
        // Se descarta cualquier archivo seleccionado sin guardar (p.ej. al cancelar edición o recargar el producto)
        this.imageSlots = {};
      }
      const total = count || 0;
      const list = [];
      for (let i = 0; i < total; i++) {
        const letter = String.fromCharCode(i + 97);
        if (!this.imageSlots[letter]) {
          // Se conserva el slot en imageSlots aunque imageCount se reduzca temporalmente,
          // para no perder el archivo/preview ya seleccionado si el usuario vuelve a subir el contador
          this.imageSlots[letter] = {
            id: letter,
            imageName: `${this.data_local.id}${letter}.png`,
            preview: this.data_local.id ? [this.imagesURL, '/products%2F', this.data_local.id, letter, '.png?alt=media'].join('') : null,
            file: null,
            removed: false
          };
        }
        list.push(this.imageSlots[letter]);
      }
      this.extraImages = list;
    },
    convertToPng(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          canvas.toBlob(blob => {
            URL.revokeObjectURL(url);
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('No se pudo convertir la imagen a formato PNG'));
            }
          }, 'image/png');
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          reject(new Error('No se pudo leer el archivo de imagen seleccionado'));
        };
        img.src = url;
      });
    },
    pickFile(image) {
      const input = this.getInputRef(image);
      if (!input) {
        return;
      }
      const file = input.files;
      if (!(file && file[0])) {
        return;
      }
      if (image == null) {
        const reader = new FileReader;
        reader.onload = e => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
      } else {
        const self = this;
        this.convertToPng(file[0])
          .then(blob => {
            image.file = blob;
            image.removed = false;
            const reader = new FileReader;
            reader.onload = e => {
              image.preview = e.target.result;
              self.recalcImageCount();
            };
            reader.readAsDataURL(blob);
          })
          .catch(error => {
            self.$vs.notify({
              title: 'Error al procesar imagen',
              text: error.message,
              color: 'danger'
            });
          });
      }
    },
    getData(id) {
      if (id) {
        if (id == 0) {
          this.$vs.loading.close();
          this.loaded = true;
          this.id_not_found = false;
          this.editing = true;
        } else if (this.$store.products) {
          this.data = {...this.data_local, ...this.$store.getters.getProduct(id)};
          this.reset_data();
        } else {
          const self = this;
          setTimeout(function () {
            self.data = {...self.data_local, ...self.$store.getters.getProduct(id)};
            self.reset_data();
          }, 750);
        }
      } else {
        this.$vs.loading.close();
        this.loaded = true;
        if (id == 0) {
          this.id_not_found = false;
        }
        this.editing = true;
      }
    },
    validateForm() {
      let message = '';
      if (this.data_local.isbn.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe indicar un código`;
        // message += (message == '' ? '' : '<br/>') + 'Debe indicar un código';
      }
      if (this.data_local.name.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe indicar una descripción`;
      }
      if (this.data_local.versionId.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe seleccionar una versión`;
      }
      if (this.data_local.categoryList.length == 0) {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe seleccionar por lo menos un elemento en categorías incluídas`
      }
      if (this.data_local.status.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe seleccionar una estado`
      }
      if (message != '') {
        this.$vs.notify({
          title: 'Error validando información',
          text: message,
          color: 'danger'
        });
      }
      return (message == '');
    },
    uploadMainImage(imageFile, newId) {
      const fileParts = imageFile.name.split('.');
      let extension = '.';
      if (fileParts.length > 1) {
        extension = `.${fileParts[1]}`;
      }
      const imageRef = storage.ref().child(`products/${newId}${extension}`);
      return imageRef.put(imageFile);
    },
    deleteExtraImage(newId, letter) {
      const imageRef = storage.ref().child(`products/${newId}${letter}.png`);
      return imageRef.delete().catch(error => {
        // Se ignora el error cuando la imagen nunca existió en Storage
        if (error && error.code === 'storage/object-not-found') {
          return null;
        }
        throw error;
      });
    },
    moveExtraImage(newId, fromLetter, toLetter) {
      // Traslada el contenido ya almacenado de una letra a otra cuando un slot se elimina
      // y los slots siguientes se renumeran para conservar letras consecutivas.
      // NOTA: el "fetch" de la URL de descarga requiere que el bucket de Storage tenga
      // configurado CORS para el dominio de hosting desplegado; sin esa configuración,
      // el movimiento falla (la imagen de origen no se pierde: solo no se replica en la
      // letra nueva ni se borra la anterior) y debe corregirse la configuración de CORS.
      const fromRef = storage.ref().child(`products/${newId}${fromLetter}.png`);
      return fromRef.getDownloadURL()
        .then(url => fetch(url))
        .then(response => {
          if (!response.ok) {
            throw new Error(`No se pudo descargar la imagen de la letra "${fromLetter}" para moverla (HTTP ${response.status})`);
          }
          return response.blob();
        })
        .then(blob => {
          const toRef = storage.ref().child(`products/${newId}${toLetter}.png`);
          return toRef.put(blob, {contentType: 'image/png'});
        })
        .then(() => fromRef.delete())
        .catch(error => {
          // Se ignora el error cuando la imagen nunca existió en Storage
          if (error && error.code === 'storage/object-not-found') {
            return null;
          }
          if (error instanceof TypeError) {
            // Los errores de red/CORS al hacer fetch de la URL de descarga llegan como
            // TypeError; se envuelven con un mensaje más claro para facilitar el diagnóstico
            throw new Error(`No se pudo mover la imagen de la letra "${fromLetter}" a "${toLetter}" (posible problema de CORS en Storage): ${error.message}`);
          }
          throw error;
        });
    },
    uploadExtraImages(newId) {
      const operations = [];
      const currentLetters = new Set(this.extraImages.map(image => image.id));
      // Se toma una copia de los movimientos/eliminaciones pendientes y solo se limpian del
      // estado del componente una vez que la subida se resuelve correctamente; así, si falla,
      // se conservan para poder reintentarlos en el siguiente guardado en lugar de perderlos.
      const movesToRun = this.pendingImageMoves;
      const deletesToRun = this.pendingImageDeletes;
      movesToRun.forEach(move => {
        operations.push(this.moveExtraImage(newId, move.fromLetter, move.toLetter));
      });
      deletesToRun.forEach(letter => {
        operations.push(this.deleteExtraImage(newId, letter));
      });
      this.extraImages.forEach(image => {
        if (image.file) {
          const imageRef = storage.ref().child(`products/${newId}${image.id}.png`);
          operations.push(imageRef.put(image.file, {contentType: 'image/png'}));
        } else if (image.removed) {
          operations.push(this.deleteExtraImage(newId, image.id));
        }
      });
      // Elimina en Storage cualquier slot que haya existido en esta sesión de edición
      // pero que ya no esté dentro del imageCount actual (p.ej. tras reducir el contador)
      Object.keys(this.imageSlots).forEach(letter => {
        if (!currentLetters.has(letter)) {
          operations.push(this.deleteExtraImage(newId, letter));
        }
      });
      return Promise.all(operations).then(result => {
        this.pendingImageMoves = this.pendingImageMoves.filter(move => !movesToRun.includes(move));
        this.pendingImageDeletes = this.pendingImageDeletes.filter(letter => !deletesToRun.includes(letter));
        return result;
      });
    },
    updateList(list, newId) {
      const self = this;
      db.collection('catalogs').doc('products').update({list: list})
        .then(() => {
          const uploads = [];
          if (self.$refs.fileInput && self.$refs.fileInput.files && self.$refs.fileInput.files.length > 0) {
            uploads.push(self.uploadMainImage(self.$refs.fileInput.files[0], newId));
          }
          uploads.push(self.uploadExtraImages(newId));
          Promise.all(uploads)
            .then(() => {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos del producto fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'product', params: {id: newId}});
              }
              self.editing = false;
              self.$vs.loading.close();
            })
            .catch((error) => {
              self.$vs.notify({
                title: 'ADVERTENCIA',
                text: `Datos del producto fueron actualizados correctamente pero ocurrió un error al actualizar imágenes: ${error.message}`,
                color: 'warning'
              });
              if (self.id == 0) {
                self.$router.push({name: 'product', params: {id: newId}});
              }
              self.editing = false;
              self.$vs.loading.close();
            });
        })
        .catch((error) => {
          self.$vs.notify({
            title: 'Error al actualizar',
            text: error.message,
            color: 'danger'
          });
          self.$vs.loading.close();
        })
    },
    save() {
      if (this.validateForm()) {
        this.$vs.loading({
          text: 'Guardando información de producto',
          type: 'point'
        });
        if (typeof this.$refs.description == 'string') {
          this.data_local.description = this.$refs.description;
        }
        this.data_local.searchField = `${this.data_local.isbn} | ${this.data_local.name}`;
        this.data_local.statusName = this.data_local.status == 'ACT' ? 'Activo' : 'Inactivo';
        // Se utiliza la lista cruda del state y no el getter productsList, para no
        // persistir en Firebase los campos calculados por el getter (originalPrice,
        // categoryName, etc.) y para no excluir productos sin categorías asignadas.
        const list = (this.$store.state.products && this.$store.state.products.list) ? JSON.parse(JSON.stringify(this.$store.state.products.list)) : [];
        if (this.data_local.id > 0) {
          const index = list.findIndex(i => i.id === this.data_local.id);
          if (index >= 0) {
            const categories = this.data_local.categoryList.join(',');
            const variations = this.data_local.variationsList.join(',');
            list[index] = JSON.parse(JSON.stringify(this.data_local));
            list[index].categories = categories;
            list[index].variations = variations;
            // Se eliminan campos calculados por el getter que no deben persistirse
            delete list[index].categoryName;
            delete list[index].categoryList;
            delete list[index].variationsList;
            this.updateList(list, this.data_local.id);
          }
        } else {
          const self = this;
          db.collection('catalogs').doc('products').update({sequence: firebase.firestore.FieldValue.increment(1)})
            .then(() => {
              const data = {...self.data_local};
              db.collection('catalogs').doc('products').get()
                .then(doc => {
                  if (doc.exists) {
                    const newId = doc.data();
                    data.id = newId.sequence;
                    data.categories = data.categoryList.join(',');
                    data.variations = data.variationsList.join(',');
                    delete data.categoryName;
                    delete data.categoryList;
                    delete data.variationsList;
                    list.push(data);
                    self.updateList(list, data.id);
                  }
                })
                .catch((error) => {
                  self.$vs.notify({
                    title: 'Error al obtener secuencia',
                    text: error.message,
                    color: 'danger'
                  });
                  self.$vs.loading.close();
                });
            })
            .catch((error) => {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: error.message,
                color: 'danger'
              });
              self.$vs.loading.close();
            });
        }
      }
    },
    confirmDeleteRecord() {
      console.log('Delete');
    },
    fetchOdooPrice() {
      const self = this;
      const isbn = this.data_local.isbn;
      if (!isbn || isbn.trim() === '') {
        this.$vs.notify({
          title: 'Error',
          text: 'El producto no tiene ISBN',
          color: 'danger'
        });
        return;
      }
      db.collection('parameters').doc('orders').get()
        .then(doc => {
          if (!doc.exists) {
            throw new Error('No se encontró la configuración de Odoo');
          }
          const apiURL = doc.data().odooFullAPI;
          if (!apiURL) {
            throw new Error('No se encontró la URL de la API de Odoo');
          }
          return fetch(`${apiURL}/get_price_isbn`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ isbn: isbn })
          });
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Error en la API de Odoo (HTTP ${response.status})`);
          }
          return response.json();
        })
        .then(data => {
          if (data.price != null) {
            self.data_local.price = data.price;
            self.data_local.originalPrice = data.price;
            self.$vs.notify({
              title: 'Precios actualizados',
              text: 'Se cargaron los precios desde Odoo',
              color: 'success'
            });
          } else {
            throw new Error('La respuesta de Odoo no incluye el campo price');
          }
        })
        .catch(error => {
          self.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: 'Error al cargar precio',
            text: error.message || 'Ocurrió un error al consultar el precio desde Odoo',
            acceptText: 'Cerrar',
            cancelText: null,
            showCancelButton: false
          });
        });
    }
  },

  mounted() {
    this.id = parseInt(this.$route.params.id);
    const self = this;
    setTimeout(function () {
      self.getData(self.id);
    }, 750);
  }
}
</script>

<style lang="scss">
@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
/*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-lists/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
/*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
@import "../../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
</style>
